<template>
  <form class="needs-validation" @submit.prevent="addAdmin" novalidate>
    <div class="col px-0 pr-lg-3">
      <section class="bg-white rounded mb-4 p-3 p-sm-4">
        <page-heading>{{ edit ? 'Edit' : 'Add' }} Secretary</page-heading>
        <div class="text-center p-2" v-if="!memberDetailsHasData && edit">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="alert alert-warning" v-if="errors">{{errors}}</div>

        <div class="f-form">
          <div class="f-form__pair f-form__pair--1-3">
            <f-group label="Title" id="title" required tooltip="Please include the title.">
              <select class="form-control" id="title" required v-model="memberUpdate.title">
                <option disabled></option>
                <option v-for="title in TITLES" :key="title" :value="title">{{ title }}</option>
              </select>
            </f-group>
            <f-text id="firstName" label="First Name" required maxlength="40" tooltip="Please include the First Name." v-model="memberUpdate.first_name" />
          </div>
          <div class="f-form__half">
            <f-text id="lastName" label="Last Name" required maxlength="40" tooltip="Please include the Last Name." v-model="memberUpdate.last_name" />
          </div>

          <div class="f-form__half">
            <f-text id="email" label="Email Address" type="email" required maxlength="255" tooltip="Please include the Email Address." v-model="memberUpdate.attributes.email" />
          </div>
          <div class="f-form__half">
            <f-text id="phone" label="Phone Number" required maxlength="15" tooltip="Please include the Phone Number." v-model="memberUpdate.attributes.phone" />
          </div>

          <div class="f-form__half">
            <f-text id="password" label="Password" type="password" :required="!edit" maxlength="30" pattern="([A-Za-z0-9]){6,}" tooltip="Please include a Password of at least 6 characters, using only letters and numbers." v-model="password.password" />
          </div>
          <div class="f-form__half">
            <f-text id="confirmPassword" label="Confirm Password" type="password" :required="!edit" maxlength="30" tooltip="Please ensure the password matches." v-model="password.confirmPassword" />
          </div>

          <div class="f-form__full" v-if="edit && memberUpdate.id">
            <super-secretary-toggle :memberId="memberUpdate.id" v-model="memberUpdate.is_super_secretary" />
          </div>
        </div>

        <div class="d-lg-none justify-content-end">
          <button class="btn btn-block-mob btn-outline-primary" v-if="edit && memberUpdate.id && loggedInUser !== memberUpdate.id && memberUpdate.role !== 'Secretary'" @click.prevent="showModal = true">Delete</button>
          <button class="btn btn-block-mob btn-primary ml-lg-2" @click="handleSubmit">{{edit ? 'Update' : 'Add Secretary' }}</button>
        </div>
      </section>
    </div>

    <desktop-action-bar>
      <button class="btn btn-block btn-primary" @click="handleSubmit">{{edit ? 'Update' : 'Add Secretary' }}</button>
      <button class="btn btn-block btn-outline-primary mt-2" v-if="edit && memberUpdate.id && loggedInUser !== memberUpdate.id && memberUpdate.role !== 'Secretary'" @click.prevent="showModal = true">Delete</button>
    </desktop-action-bar>

    <!-- use the modal component, pass in the prop -->
    <modal v-if="showModal" @close="showModal = false">
      <div slot="body">
        <div class="alert alert-warning text-center">
          <strong>Warning!</strong>
          <p>You are about to delete this record permanently. Are you sure?</p>
        </div>
      </div>
      <div slot="footer">
        <div class="col-12 d-flex justify-content-center">
          <button class="btn btn-primary" @click.prevent="showModal = false;deleteSecretary()">Confirm</button>
          <button class="btn btn-outline-primary ml-2" @click.prevent="showModal = false">Cancel</button>
        </div>
      </div>
    </modal>
  </form>
</template>

<script>
import axios from 'axios'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import modal from '@/components/Modal'
import SuperSecretaryToggle from '@/components/Members/SuperSecretaryToggle'
import DesktopActionBar from '@/components/DesktopActionBar'
import PageHeading from '@/components/PageHeading'
import FGroup from '@/components/FormFields/Base/FGroup'
import FText from '@/components/FormFields/FText'

const TITLES = ['Mr', 'Ms', 'Miss', 'Mrs', 'Dr']

export default {
  name: 'SecretaryAddDetails',
  props: ['memberDetails', 'edit'],
  mixins: [HANDLESUBMIT],
  components: {
    modal,
    SuperSecretaryToggle,
    DesktopActionBar,
    PageHeading,
    FGroup,
    FText
  },
  data() {
    return {
      TITLES,
      memberUpdate: { attributes: {} },
      memberDetailsHasData: false,
      showModal: false,
      success: '',
      errors: '',
      loggedInUser: Number(localStorage.userID)
    }
  },
  watch: {
    memberDetails() {
      if (Object.keys(this.memberDetails).length > 0) {
        this.memberUpdate = this.memberDetails
        this.memberDetailsHasData = true
      }
    }
  },
  methods: {
    addAdmin() {
      setTimeout(() => {
        const fields = this.memberUpdate
        const id = this.memberDetails ? this.memberDetails.id : null
        if (this.formComplete) {
          axios.post(`${this.$api}/admin/secretary`, {
            id,
            title: fields.title,
            first_name: fields.first_name,
            last_name: fields.last_name,
            email: fields.attributes.email,
            phone: fields.attributes.phone,
            password: this.password.password,
            password_confirmation: this.password.confirmPassword,
            edit: !!this.edit
          }).then((response) => {
            if (response.data.status === 'success') {
              this.$router.push({ name: 'Secretary Users', params: { success: `Secretary ${this.edit ? 'edited' : 'created'} successfully.` } })
            } else if (response.data.errors.email) {
              // Email
              this.success = ''
              this.errorStatus = 'email'
              if (response?.data?.errors?.email[0]) {
                this.errors = response.data.errors.email[0]
              } else {
                this.errors = 'Please include correct email address.'
              }
            } else {
              this.success = ''
              this.errors = 'Please ensure all fields are completed.'
            }
          }).catch((error) => {
            // eslint-disable-next-line
            console.log(error)
          })
        }
      }, 10)
    },
    deleteSecretary() {
      axios.post(`${this.$api}/admin/delete-secretary`, {
        id: this.memberUpdate.id
      }).then((response) => {
        if (response.data.status === 'success') {
          this.$router.push({ name: 'Secretary Users', params: { success: 'Secretary removed successfully.' } })
        } else if (response.data.status === 'self_deletion') {
          this.success = ''
          this.errors = 'You are unable to delete your own account.'
        }
      }).catch((error) => {
        // eslint-disable-next-line
        console.log(error)
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/Admin/Add/SecretaryAddDetails.vue